<template>
  <div class="table__container">
    <div v-for="(client, idx) in tickets.getItems()" :key="`ticket-client-${idx}`">
      <span v-if="client.getTitle()" class="table__title">{{ client.getTitle() }}</span>
      <HeaderBox queue-table-hook>
        <HeaderBoxItem>
          {{ getTicketTitle }}
        </HeaderBoxItem>
        <HeaderBoxItem right>
          {{ getExecutorTitle }}
        </HeaderBoxItem>
      </HeaderBox>
      <TicketList ref="ticketList">
        <template v-for="(ticket, index) in client.getTickets()">
          <TicketListItem queue-ticket-list-item-hook :key="`ticket-list-item-${index}-${ticket.id}`">
            <Ticket
              queue-ticket-hook
              :queue-ticket-label-hook="ticket.seatLabel"
              :queue-ticket-number-hook="ticket.ticketNumber"
              :queue-ticket-title-hook="ticket.title"
              :item="ticket"
            />
          </TicketListItem>
        </template>
      </TicketList>
    </div>
  </div>
</template>

<script>
import Ticket from '@/components/tickets/Ticket'
import HeaderBox from '@/components/headers/HeaderBox'
import TicketList from '@/components/tickets/TicketList'
import HeaderBoxItem from '@/components/headers/HeaderBoxItem'
import TicketListItem from '@/components/tickets/TicketListItem'
import ClientsQueue from '@/app/model/clients/clients-queue'

export default {
  name: 'TableDiffClients',
  components: {
    Ticket,
    HeaderBox,
    TicketList,
    HeaderBoxItem,
    TicketListItem
  },
  props: {
    tickets: {
      type: ClientsQueue,
      require: true
    }
  },
  computed: {
    getTicketTitle () {
      return this.$store.state.gui.settings.colorScheme.ticketTitle
        ? this.$store.state.gui.settings.colorScheme.ticketTitle
        : this.$t('common.talon')
    },
    getExecutorTitle () {
      return this.$store.state.gui.settings.colorScheme.executorTitle
        ? this.$store.state.gui.settings.colorScheme.executorTitle
        : this.$t('common.windowNumber')
    }
  }
}
</script>

<style lang="stylus">
.table__container {
  display flex
  justify-content space-between
  gap 2vw

  div {
    flex 1
  }

  .header-box {
    padding-top 1vh
  }

  .header-box-item {
    font-size 1.5vw
  }

  .ticket {
    padding-top 0.25em

    &-list {
      min-height initial
      max-height 70vh
      overflow hidden
    }

    &__number {
      font-size 3vw
    }

    &__window {
      font-size 3vw
      text-align end
    }

    &__state {
      display none
    }

    &__name {
      font-size 1.5vw
    }

    &:before {
      left -30px
      right -30px
    }
  }
}

.table__title {
  display flex
  justify-content center
  font-size 2.5vw
  font-weight 500
  line-height normal
  margin-top 1vh
}
</style>
